import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';

function SessionStaleBanner({ message, onDismiss }) {
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '10px 16px',
        background: 'rgba(40, 28, 8, 0.96)',
        borderBottom: '1px solid rgba(200, 168, 75, 0.45)',
        color: 'rgba(255,255,255,0.92)',
        fontSize: 13,
        lineHeight: 1.4,
        boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
      }}
    >
      <span style={{ flex: 1 }}>{message}</span>
      <button
        type="button"
        onClick={onDismiss}
        style={{
          flexShrink: 0,
          background: 'rgba(200,168,75,0.2)',
          border: '1px solid rgba(200,168,75,0.5)',
          color: '#C8A84B',
          borderRadius: 8,
          padding: '6px 12px',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Entendido
      </button>
    </div>
  );
}

/** Banner fijo en document.body; compatible con early returns de Marketplace. */
export function useSessionStaleBanner(message, onDismiss) {
  const rootRef = useRef(null);
  const hostRef = useRef(null);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const unmount = () => {
      rootRef.current?.unmount();
      rootRef.current = null;
      hostRef.current?.remove();
      hostRef.current = null;
    };

    if (!message) {
      unmount();
      return undefined;
    }

    let host = document.getElementById('dv-session-stale-banner');
    if (!host) {
      host = document.createElement('div');
      host.id = 'dv-session-stale-banner';
      document.body.appendChild(host);
    }
    hostRef.current = host;
    if (!rootRef.current) rootRef.current = createRoot(host);
    rootRef.current.render(
      <SessionStaleBanner message={message} onDismiss={onDismiss || (() => {})} />
    );

    return unmount;
  }, [message, onDismiss]);
}
